import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import {
  ICreateFacilityDto,
  IUpdateFacilityDto,
} from 'common/src/types/facility.dtos';
import { IFacility, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getFacilities = async (
  params?: DataQueryParams,
): Promise<IPage<IFacility>> =>
  await getRequest(API_BASE_PATHS.FACILITIES, formatQueryParams(params));

export const addFacilities = async (
  body: ICreateFacilityDto,
): Promise<string> => await postRequest(API_BASE_PATHS.FACILITIES, {}, body);

export const addFacilityToEnergyStar = async (
  id: string,
  syncStartDate: string,
): Promise<void> =>
  await postRequest(
    `${API_BASE_PATHS.FACILITIES}/${id}/addToEnergyStar`,
    {},
    { syncStartDate },
  );

export const updateEnergyStarScoreAndMetrics = async (
  id: string,
  body: any,
): Promise<void> =>
  await postRequest(
    `${API_BASE_PATHS.FACILITIES}/${id}/updateEnergyStarScoreAndMetrics`,
    {},
    body,
  );

export const updateFacilities = async (
  id: string,
  body: IUpdateFacilityDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.FACILITIES}/${id}`, {}, body);

export const deleteFacility = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.FACILITIES}/${id}`);
